module.exports = __webpack_public_path__ + "img/WhatsApp.d543aa85.png";